<footer class="app-footer" role="contentinfo">
  <a
    *ngIf="showShortcutKeysLink"
    class="app-footer__link"
    [routerLink]="['/shortcut-keys']"
    [queryParams]="footerShortcutQueryParams"
    target="_blank"
    rel="noopener noreferrer"
  >
    Show Shortcut Keys
  </a>
</footer>
